import { Button as JoyButton, ButtonProps } from '@mui/joy';
import { MagicWand } from '@phosphor-icons/react';

export const Button = ({ sx, ...props }: ButtonProps) => {
  return (
    <JoyButton
      startDecorator={<MagicWand />}
      sx={{
        background: 'linear-gradient(45deg, #6932F9 30%, #A12CE7 90%)',
        color: (theme) => theme.vars.palette.common.white,
        '&:hover': {
          background: 'linear-gradient(45deg, #7942FF 30%, #B13CF8 90%)',
        },
        ...sx,
      }}
      {...props}
    />
  );
};
